var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('PageHeader',{attrs:{"title":_vm.title,"subheader":_vm.subheader}}),_c('v-card',{staticClass:"pa-5"},[_c('products-list',{attrs:{"flash":""}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }